import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth.service';
import { Brand } from '@features/brand/interfaces/brand.interface';
import { BrandService } from '@features/brand/services/brand.service';
import { Category } from '@features/category/interfaces/category.interface';
import { CategoryService } from '@features/category/services/category.service';
import { User } from '@features/user/interfaces/user.interface';
import { UserService } from '@features/user/services/user.service';
import {
  faAngleRight,
  faBagShopping,
  faBars,
  faBook,
  faChevronDown,
  faCoins,
  faCreditCard,
  faFileContract,
  faGauge,
  faHeart,
  faLayerGroup,
  faMessage,
  faMoneyCheckDollar,
  faQuestion,
  faRightFromBracket,
  faSquarePlus,
  faTimes,
  faUser,
  faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'fc-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.css'],
})
export class MobileMenuComponent implements OnInit {
  // font awesome
  faUser = faUser;
  faTimes = faTimes;
  faCreditCard = faCreditCard;
  faMoneyCheckDollar = faMoneyCheckDollar;
  faCoins = faCoins;
  faBagShopping = faBagShopping;
  faMessage = faMessage;
  faHeart = faHeart;
  faGauge = faGauge;
  faWandMagicSparkles = faWandMagicSparkles;
  faRightFromBrcket = faRightFromBracket;
  faSquarePlus = faSquarePlus;
  faAngleRight = faAngleRight;
  faBars = faBars;
  faBook = faBook;
  faQuestion = faQuestion;
  faFileContract = faFileContract;
  faLayerGroup = faLayerGroup;
  faChevronDown = faChevronDown;

  @ViewChild('mainMenuDrawer') mainMenuDrawer: any;
  @ViewChild('categoryDrawer') categoryDrawer: any;
  @ViewChild('brandDrawer') brandDrawer: any;

  showCategory: boolean = true;
  selectedCategorySlugs: any = [];
  categories: Category[] = [];
  brands: Brand[] = [];

  @Input() user?: User;
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private categoryService: CategoryService,
    private brandService: BrandService,
    private router: Router
  ) {
    forkJoin([
      this.brandService.getBrands(),
      this.categoryService.getCategories(),
    ]).subscribe(([brandRes, categoryRes]: any) => {
      this.brands = brandRes;
      this.categories = categoryRes.categories;
    });
  }

  ngOnInit(): void {}
  logout() {
    this.authService.logout().subscribe();
  }
  onSelectCategory(
    category1: string,
    category2: string = '',
    category3: string = ''
  ) {
    let categorySlugs: any = [category1];
    if (category2) categorySlugs.push(category2);
    if (category3) categorySlugs.push(category3);
    if (categorySlugs) {
      this.selectedCategorySlugs = categorySlugs;
    }
    this.router.navigate(['/product'], {
      queryParams: { categories: this.selectedCategorySlugs.join(', ') },
    });
    this.hideAllDrawer();
  }
  onSelectBrand(brand: any) {
    this.router.navigate(['/product'], {
      queryParams: { brands: brand },
    });
    this.hideAllDrawer();
  }
  hideAllDrawer() {
    this.mainMenuDrawer.hide();
    this.categoryDrawer.hide();
    this.brandDrawer.hide();
  }
  verifyEmail() {
    this.userService.resendVerifyEmail().subscribe();
  }
}
